module.exports = "<select></select>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/select2/select2.html
// module id = 509
// module chunks = 0